import { create } from "zustand";
import { UploadedImage } from "../../PostFormModal.types";

type MediaFilesSlice = {
    images: UploadedImage[];
    isUploading: boolean;
    setImages: (images: UploadedImage[]) => void;
    setIsUploading: (value: boolean) => void;
};

export const usePostFormPollMediaFilesUploadInputStore =
    create<MediaFilesSlice>()((set) => ({
        images: [],
        setImages: (images) => set({ images }),
        isUploading: false,
        setIsUploading: (isUploading) => {
            set({ isUploading });
        },
    }));
